import EditRoundedIcon from "@mui/icons-material/EditRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import {
  Backdrop,
  IconButton,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import { NUCLEO_FAMILIARE } from "../../../utils/constants/tables";
import EditChildren from "./EditChildren";
import EditFamily from "./EditFamily";
import FormNucleo from "./FormNucleo";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";

const AssociateFamily = ({
  family,
  children,
  isLoadingMember,
  onDeleteChildren,
  onDeleteFamily,
  onCreateFamily,
  onCreateChildren,
  onEditFamily,
  onEditChildren,
  isLoading,
  userId,
  hideTitle,
}) => {
  const [open, setOpen] = useState(false);
  const [openChildren, setOpenChildren] = useState(false);
  const [openFamily, setOpenFamily] = useState(false);

  const [data, setData] = useState("");

  const handleOpen = (data) => {
    setData(data);
    setOpen(true);
  };

  const handleOpenChildren = (data) => {
    setData(data);
    setOpenChildren(true);
  };

  const handleOpenFamily = (data) => {
    setData(data);
    setOpenFamily(true);
  };

  const handleClose = () => setOpen(false);
  const handleCloseChildren = () => setOpenChildren(false);
  const handleCloseFamily = () => setOpenFamily(false);

  return (
    <div>
      <div className="flex justify-between items-center">
        {hideTitle ? <div> </div> : <h3>Nucleo Familiare</h3>}

        <CoreButtonHoverIcon
          className="text-blue-600  m-1"
          icon={
            <PersonAddAltRoundedIcon
              fontSize="small"
              className="text-blue-600 "
            />
          }
          testo="Aggiungi"
          onClick={handleOpen}
        />
      </div>

      <TableContainer sx={{ position: "relative" }}>
        <Backdrop
          className="backdrop-animation w-full h-full"
          sx={{ zIndex: 3 }}
          open={isLoadingMember}
        />
        <Table>
          <TableHead>
            <TableRow>
              {NUCLEO_FAMILIARE().map((el) => (
                <TableCell className="font-bold " key={el.id}>
                  {el.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {family.length !== 0 ? (
            family?.map((el, id) => (
              <TableRow key={id}>
                <TableCell>{`${el.name} ${el.surname}`}</TableCell>
                <TableCell>{el.codiceFiscale}</TableCell>
                <TableCell>
                  <IconButton
                    disabled={isLoading}
                    key={id}
                    variant="outlined"
                    onClick={() => onDeleteFamily(el.id)}
                  >
                    <HighlightOffRoundedIcon
                      fontSize="small"
                      className="text-rose-700"
                    />
                  </IconButton>
                  <IconButton
                    key={id}
                    variant="outlined"
                    onClick={() => handleOpenFamily(el)}
                  >
                    <EditRoundedIcon
                      fontSize="small"
                      className="text-blue-700"
                    />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3}>
                <p className="text-center text-gray">Nessun Membro</p>
              </TableCell>
            </TableRow>
          )}

          {children ? (
            children?.map((el, id) => (
              <TableRow key={id}>
                <TableCell>{`${el.name} ${el.surname}`}</TableCell>
                <TableCell>{el.codiceFiscale}</TableCell>
                <TableCell>
                  <IconButton
                    key={id}
                    variant="outlined"
                    onClick={() => onDeleteChildren(el.id)}
                    disabled={isLoading}
                  >
                    <HighlightOffRoundedIcon
                      fontSize="small"
                      className="text-rose-700"
                    />
                  </IconButton>
                  <IconButton
                    key={id}
                    variant="outlined"
                    onClick={() => handleOpenChildren(el)}
                  >
                    <EditRoundedIcon
                      fontSize="small"
                      className="text-blue-700"
                    />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3}>
                <p className=" text-center text-gray">Nessun Figlio/a</p>
              </TableCell>
            </TableRow>
          )}
        </Table>
      </TableContainer>

      <CoreModal
        width={900}
        height={800}
        state={open}
        onClose={handleClose}
        component={
          <FormNucleo
            dataChildren={data}
            dataFamily={data}
            userId={userId}
            close={handleClose}
            onCreateChildren={onCreateChildren}
            onCreateFamily={onCreateFamily}
            isLoading={isLoading}
          />
        }
      />

      <CoreModal
        width={900}
        height={800}
        state={openChildren}
        onClose={handleCloseChildren}
        component={
          <EditChildren
            dataChildren={data}
            close={handleCloseChildren}
            onEditChildren={onEditChildren}
            userId={userId}
            isLoading={isLoading}
          />
        }
      />

      <CoreModal
        width={900}
        height={800}
        state={openFamily}
        onClose={handleCloseFamily}
        component={
          <EditFamily
            dataFamily={data}
            close={handleCloseFamily}
            onEditFamily={onEditFamily}
            userId={userId}
            isLoading={isLoading}
          />
        }
      />
    </div>
  );
};

export default AssociateFamily;
